var _g, _rect, _path, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputOutputInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 100,
    height: 100,
    rx: 4,
    fill: "#475076"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    stroke: "#707B7F",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6 65 20.426-20.426a4 4 0 0 1 5.379-.253l11.28 9.336a4 4 0 0 0 5.147-.039L74.24 21.185a4 4 0 0 1 5.15-.036L109 45.71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 28,
    r: 8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102026",
    d: "M1 67h100v16H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56 67h2v16h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAF9",
    d: "M1 83h100v22H1z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 91,
    width: 71,
    height: 6,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 91,
    width: 71,
    height: 6,
    rx: 2,
    fill: "#102026",
    stroke: "#102026",
    strokeWidth: 6,
    mask: "url(#c)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 101,
    height: 101,
    rx: 4.5,
    stroke: "#102026"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113 54a1 1 0 0 0 0 2v-2Zm20.707 1.707a1 1 0 0 0 0-1.414l-6.364-6.364a1 1 0 1 0-1.414 1.414L131.586 55l-5.657 5.657a1 1 0 1 0 1.414 1.414l6.364-6.364ZM113 56h20v-2h-20v2Z",
    fill: "#E2E9EB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 5,
    width: 100,
    height: 100,
    rx: 4,
    fill: "#475076"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    stroke: "#707B7F",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m138 65 20.426-20.426a4 4 0 0 1 5.379-.253l11.28 9.336a4 4 0 0 0 5.147-.039l38.008-32.433a4 4 0 0 1 5.15-.036L253 45.71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 28,
    r: 8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102026",
    d: "M145 67h100v16H145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M200 67h2v16h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAF9",
    d: "M145 83h100v22H145z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.5,
    y: 91,
    width: 71,
    height: 6,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159.5,
    y: 91,
    width: 71,
    height: 6,
    rx: 2,
    fill: "#102026",
    stroke: "#102026",
    strokeWidth: 6,
    mask: "url(#f)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142.5,
    y: 2.5,
    width: 105,
    height: 105,
    rx: 6.5,
    stroke: "#9FAB5A",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 100,
    height: 100,
    rx: 4,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 5)",
    d: "M0 0h100v62H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 5,
    width: 100,
    height: 100,
    rx: 4,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(145 5)",
    d: "M0 0h100v62H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputOutputInfo);
export default __webpack_public_path__ + "static/media/input-output-info.c408052d8fbe2fd60bc626851910f803.svg";
export { ForwardRef as ReactComponent };